<template lang="pug">
include /mixins
trip-state(
  :trip_label='trip_label'
)
  template(#state='{ hasDebt, isOk, isPerfect, debt, oldDebt, actual, message }')
    +b.g-row--align_start.--appearance_spaced
      +b.g-cell.g-cols--12.--6-xl
        +b.trip-distribution-message(v-if='trip.conditions')
          +e.img.IMG(
            :src='`/static/img/totik/${message.img}.png`',
          )
          +e.content
            +e.title.P {{ message.title }}
            +e.text.P {{ message.text }} &nbsp;
              span(v-if='message.hasSum' v-html='getSplittedHtml(message.sum(), currency)')
            +e.after_text.P(
              :style="{ '--color': message.color }"
            ) {{ message.after_text }} &nbsp;
              span(v-if='message.hasAfterSum' v-html='getSplittedHtml(message.afterSum(), currency)')
      +b.g-cell.g-cols--12.--6-xl
        +b.trip-monthly-case(v-if='trip.trip_potential_participant && currentMonthDistribution')
          +e.progress.tt-space_mb--4
            chart(
              :total="Number(trip.trip_potential_participant.props.purchase_amount)"
              :bought="Number(trip.trip_potential_participant.props.total_actual_sale)"
              color="#3ecf8e"
            )
              template(#total)
                +e.head.tt-space_mb--4
                  +e.title.ds-caption--size_2md.--semibold.SPAN {{ _('Общая сумма закупки') }} &nbsp;
                    span(v-html='getSplittedHtml(Number(trip.trip_potential_participant.props.purchase_amount), currency)')
                  +e.deadline
                    +b.ds-caption--size_xs.--medium.SPAN {{ getPercent(Number(trip.trip_potential_participant.props.total_actual_sale), Number(trip.trip_potential_participant.props.purchase_amount)) }}%
          +e.sum-info.tt-space_mb--6
            +e.sum-info-element
              +b.sum.ds-caption--size_3md.--semibold.P(
                v-html='getSplittedHtml(Number(trip.trip_potential_participant.props.total_actual_sale), currency)'
              )
              +b.ds-caption--size_xs.--medium.P {{ _('фактически куплено') }}
            +e.sum-info-element
              +b.sum.ds-caption--size_3md.--semibold.P(
                v-if='(Number(trip.trip_potential_participant.props.purchase_amount) - Number(trip.trip_potential_participant.props.total_actual_sale)) > 0'
                v-html='getSplittedHtml(Number(trip.trip_potential_participant.props.purchase_amount) - Number(trip.trip_potential_participant.props.total_actual_sale), currency)'
              )
              +b.sum.ds-caption--size_3md.--semibold.P(
                v-else
                v-html='getSplittedHtml(0, currency)'
              )
              +b.ds-caption--size_xs.--medium.P {{ _('осталось') }}
    +b.trip-terms
      +b.g-row.--space_md.--space_xl-xl.--appearance_spaced.--justify_center-md.--justify_start-xl
        template(v-for='(item, index) in trip.conditions')
          +b.g-cell.g-cols--12.--6-md
            +b.trip-terms-element
              +e.head.tt-space_mb--4
                template(v-if='trip.conditions && trip.conditions.length > 1')
                  +e.index.ds-caption--size_xs.--medium.tt-space_mr--2 {{ index + 1 }}
                +e.title.ds-caption--size_2md.--medium.P {{ item.props.condition_name_for_sso }}
              +e.deposit-block.tt-space_mb--4
                //- +e.sum-block
                //-   +b.ds-caption--size_sm.--medium.tt-space_mb--1.P {{ _('Общая сумма') }}:
                //-   +e.sum.P
                //-     +b.deposit.ds-caption--size_lg.--semibold.SPAN(v-html='getSplittedHtml(item.props.actual_sale, currency)')
                //-     +b.full-amount.ds-caption--size_sm.--medium.SPAN &nbsp; / &nbsp;
                //-     +b.full-amount.ds-caption--size_sm.--medium.SPAN(v-html='getSplittedHtml(item.props.total_actual_sale, currency)')
                chart(:total="Number(item.props.total_actual_sale)" :bought="Number(item.props.actual_sale)" color="#3ecf8e" )
                +b.trip-term-value
                  +e.sum.P(
                    v-html='getSplittedHtml(item.props.actual_sale, currency)'
                  )
                  +e.text.P {{ _('фактически куплено') }}
                +b.trip-term-value
                  +e.sum.P(
                    v-html='getSplittedHtml(item.props.total_actual_sale - item.props.actual_sale, currency)'
                  )
                  +e.text.P {{ _('осталось') }}
                condition-message(
                  :condition='item'
                )
                //- +b.percent.ds-caption--size_sm.--semibold.SPAN {{ getPercent(item.props.actual_sale, item.props.total_actual_sale) }}%
              +e.button
              +b.tt-button.A(
                :href="item.props.url"
                target="_blank"
              )
                +e.title {{ _('Выбрать товары для этой закупки') }}
</template>

<script>

import {
  mapState, mapActions,
} from 'vuex'

import { format } from 'date-fns'

import {
  COUNTRY_CODE_COOKIE_NAME,
  DEFAULT_DATE_FORMAT,
} from '@app/consts'

import ConditionMessage from '@app/Trips/ConditionMessage.vue'

const chart = () => import('@app/Trips/ProgressChart.vue')

const CURRENT_MONTH_STATUS = 'current'

export default {
  props: {
    trip_label: {
      type: String,
      required: true,
    },
  },
  components: {
    chart, ConditionMessage,
  },
  data() {
    return {
      DEFAULT_DATE_FORMAT,
      currency: window.currency,
    };
  },
  computed: {
    ...mapState('trip', ['trip']),
    currentMonthDistribution() {
      if (this.trip && this.trip.trip_potential_participant && this.trip.trip_potential_participant.props) {
        return this.trip.trip_potential_participant.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS)
      }
      return null
    },
    lastDay() {
      return this.trip.trip_potential_participant.props.planned_date_of_redemption.split(' ')[0]
      // return format(this.trip.trip_potential_participant.props.planned_date_of_redemption, DEFAULT_DATE_FORMAT)
    },
  },
  mounted() {
    //   this.getTrip(this.trip_label);
    console.log(this.trip.trip_potential_participant.props);
  },
  methods: {
    format,
    ...mapActions('trip', ['getTrip']),
    // async getTripInfo() {
    //   const { data } = (await tripRetrieveResource.execute({ label: this.trip }))
    //   this.item = data.props
    // },
    getPercent(value, from) {
      return Math.round((Number(value) / Number(from)) * 100) || 0;
    },
    addCondition() {
      this.$emit('add-condition', this.condition);
      this.condition = {
        trip: this.trip,
        name: '',
        description: '',
      };
    },
  },
}

</script>
